module.exports = __webpack_public_path__ + "c_static/img/1-2手机淘宝收藏夹.81e01dd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/img/4-回购特卖入口/1-2手机淘宝收藏夹.jpg
// module id = eTcA
// module chunks = 33